import { useState } from "react";

import BasePopover from "@/components_v2/Popover/BasePopover";
import type { NotificationsPopoverProps } from "@/features/notifications/types";
import NotificationsHeader from "./components/NotificationsHeader";
import NotificationsList from "./components/NotificationsList";
import { useNotificationsFeed } from "./hooks/useNotificationsFeed";
import { useResponsive } from "@/shared/hooks/useBreakpoints";

import "./styles.css";

const NotificationsPopover = ({
  children,
  placement = "rightTop",
}: NotificationsPopoverProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const { isMobile } = useResponsive();

  const { items, unreadCount, hasMore, loadMore, refresh, markAllRead } =
    useNotificationsFeed({
      enabled: isPopoverOpen,
    });

  const handleOpenChange = (nextOpen: boolean) => {
    setIsPopoverOpen(nextOpen);
  };

  return (
    <BasePopover
      arrow={false}
      align={
        isMobile
          ? {
              offset: [-4, 8],
            }
          : {
              offset: [8, 16],
            }
      }
      placement={placement}
      getPopupContainer={(triggerNode) =>
        globalThis.document?.body ?? triggerNode
      }
      open={isPopoverOpen}
      onOpenChange={handleOpenChange}
      classNames={{ root: "notifications-popover-overlay" }}
      title={
        <NotificationsHeader
          unreadCount={unreadCount}
          onMarkAllRead={markAllRead}
        />
      }
      trigger="click"
      content={
        <div
          id="notifications-scroll-container"
          className="notifications-content-list scrollbar-neutral"
        >
          <NotificationsList
            items={items}
            hasMore={hasMore}
            onLoadMore={loadMore}
            onRefresh={refresh}
          />
        </div>
      }
    >
      {children({ isOpen: isPopoverOpen, unreadCount })}
    </BasePopover>
  );
};

export default NotificationsPopover;
